import { createConsumer, createSubscriber, IEvent } from '@cian/events-log';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  trackRecommendationsView,
  trackRecommendationItemClick,
  trackTrapRecommendationClick,
  trackRecommendationsTrapView,
} from '../tracking';
import { TRecommendationsEvent } from './types';
import { selectDealType } from '../../../selectors/filters/selectDealType';
import { useMicrofrontend } from '@cian/mf-react-legacy';
import { isRecommendationsMicrofrontendExists } from '../utils/isRecommendationsMicrofrontendExists';

export const useRecommendationsEventsSubscribe = () => {
  const dealType = useSelector(selectDealType);
  const microfrontend = useMicrofrontend();

  useEffect(() => {
    if (!isRecommendationsMicrofrontendExists(microfrontend)) {
      return () => {};
    }

    const consumer = createConsumer({ topic: 'recommendations' });

    const recommendationsSubscriber = createSubscriber((event: IEvent<unknown>) => {
      const eventData = event as TRecommendationsEvent;

      switch (eventData.type) {
        case 'show':
          trackRecommendationsView(dealType, eventData.value);

          break;
        case 'click': {
          const { suffix, offerId } = eventData.value;

          if (offerId) {
            trackRecommendationItemClick(dealType, eventData.value.products);
          } else if (suffix) {
            trackTrapRecommendationClick(dealType, suffix);
          }

          break;
        }
        case 'showTrap':
          trackRecommendationsTrapView(dealType, eventData.value.suffix);

          break;
      }
    });

    consumer.subscribe(recommendationsSubscriber);

    return () => {
      consumer.unsubscribe(recommendationsSubscriber);
      consumer.destroy();
    };
  });
};
